module.exports = __webpack_public_path__ + "1793882494189/fonts/WorkSans-Light.109accd.woff";